module.exports = __webpack_public_path__ + "img/upload_bg_10.ad42050f.png";